/**
 * SocialUpgradeModal - Consistent upgrade modal for all social-gated actions
 * Phase 4B - Social Tier Gating
 *
 * Shows UpgradeCTA inside a dismissible modal overlay.
 * "View Plans" closes modal + navigates to /pricing.
 */

import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { UpgradeCTA } from './UpgradeCTA';

interface SocialUpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  feature: string;
}

export function SocialUpgradeModal({ isOpen, onClose, feature }: SocialUpgradeModalProps) {
  // Dismiss on Escape key
  useEffect(() => {
    if (!isOpen) return;

    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-[#0A0A0A]/80 backdrop-blur-sm"
        onMouseDown={(e) => e.stopPropagation()}
        onMouseUp={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      />

      {/* Modal */}
      <div
        className="relative bg-[#0F1419] rounded-xl ring-1 ring-white/[0.06] w-full max-w-sm shadow-2xl shadow-black/50"
        onClick={(e) => e.stopPropagation()}
      >
        <UpgradeCTA feature={feature} onNavigate={onClose} />
      </div>
    </div>,
    document.body
  );
}
